export default __webpack_public_path__ + "static/media/ragdoll7XS.14f84403.webp";